import type { FlowWeightedItemRowItem } from '../components/panels/flow-landers-offers';

export function buildOffersForSelectedLander(params: {
  selectedLanderId: string | null;
  offers: FlowWeightedItemRowItem[];
  offerIdsByLanderId: Record<string, string[]> | undefined;
}): FlowWeightedItemRowItem[] {
  const { selectedLanderId, offers, offerIdsByLanderId } = params;
  if (!selectedLanderId) return offers;

  const offerIdsFromReport = new Set((offerIdsByLanderId?.[selectedLanderId] ?? []).filter(Boolean));
  if (offerIdsFromReport.size <= 0) return offers;

  const offersInReport = offers.filter((o) => offerIdsFromReport.has(o.id));
  return offersInReport;
}

